import { render } from "./GitIntegrationSettings.vue?vue&type=template&id=452497b2"
import script from "./GitIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./GitIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__